import { MORTGAGE_PROMO_TYPES } from '../../constants/newbuildingPromos';
import { IState } from '../../store';
import { IPromoInfo } from '../../types/newbuildingPromos';
import { getPromoInfos } from '../newObject/getPromoInfos';

export const selectMortgagePromos = (state: IState): IPromoInfo[] => {
  const promos = getPromoInfos(state);

  return promos.filter(promo => MORTGAGE_PROMO_TYPES.includes(promo.promoType));
};
